/* Change this file to get your personal Porfolio */
import experienceData from './shared/experience_data.json';
import degreesData from './shared/degrees_data.json';
import majorProjectsData from './shared/major_projects_data.json';
import skillsData from './shared/skills_data.json';

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

const degrees = degreesData || {
  degrees: []
};

const experience = experienceData || {
  experience: []
};
const majorProjects = majorProjectsData || {
  projects: []
};

const skills = skillsData || {
  data: []
};

//SEO Related settings
const seo = {
  title: "Lakhdeep Singh Jawandha - Senior iOS Software Engineer | React Native Developer",
  description: "Experienced Senior iOS Software Engineer with 10+ years in mobile app development. Expert in Swift, Objective-C, React Native, and team leadership. Currently based in Melbourne, Australia.",
  keywords: [
    "Lakhdeep Singh Jawandha",
    "iOS Developer",
    "React Native Developer", 
    "Swift Developer",
    "Mobile App Developer",
    "Software Engineer Melbourne",
    "ShareChat Engineer",
    "iOS Team Lead",
    "Mobile App Development",
    "Senior Software Engineer"
  ].join(", "),
  author: "Lakhdeep Singh Jawandha",
  image: "https://your-portfolio-url.com/assets/images/profile.jpg", // Add your profile image URL
  url: "https://lakhdeep.vercel.app/", // Your main portfolio URL
  og: {
    title: "Lakhdeep Singh Jawandha - Senior iOS Software Engineer Portfolio",
    type: "website",
    url: "https://lakhdeep.vercel.app/",
    image: "https://your-portfolio-url.com/assets/images/profile.jpg",
    description: "Portfolio of Lakhdeep Singh Jawandha, Senior iOS Software Engineer with 10+ years experience in mobile app development, Swift, React Native, and team leadership.",
    siteName: "Lakhdeep Singh Jawandha Portfolio"
  },
  twitter: {
    card: "summary_large_image",
    site: "@LakhdeepJawand1",
    creator: "@LakhdeepJawand1",
    title: "Lakhdeep Singh Jawandha - Senior iOS Software Engineer",
    description: "Portfolio of Senior iOS Software Engineer with 10+ years experience in mobile app development",
    image: "https://your-portfolio-url.com/assets/images/profile.jpg"
  }
};

//Home Page
const greeting = {
  title: "Lakhdeep Singh Jawandha",
  logo_name: "Lakhdeep",
  nickname: "Lakhdeep",
  subTitle:
    "Experienced Senior iOS Software Engineer with 10 Years of Experience in Client and Product Apps and Strong Team Leadership Skills.",
  resumeLink:
    "https://drive.google.com/file/d/1OyCpD-mLI3D3PGDj2b0kO6Xdl_Dymbq_/view",
  portfolio_repository: "https://github.com/lakhdeepjawandha/masterPortfolio",
  githubProfile: "https://github.com/lakhdeepjawandha",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/lakhdeepjawandha",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/lakhdeepsingh/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  // {
  //   name: "YouTube",
  //   link: " ",
  //   fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
  //   backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  // },
  {
    name: "Stack Overflow",
    link: "https://stackoverflow.com/users/5238957/lakhdeep-singh",
    fontAwesomeIcon: "fa-brands fa-stack-overflow", // Reference https://fontawesome.com/icons/stack-overflow?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  // {
  //   name: "Shadertoy",
  //   link: "https://www.shadertoy.com/user/lakhdeep92",
  //   fontAwesomeIcon: "fa-google",
  //   backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  // },
  {
    name: "Gmail",
    link: "mailto:lakhdeepjawandha@gmail.com",
    fontAwesomeIcon: "fa-google",
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "X-Twitter",
    link: "https://x.com/LakhdeepJawand1",
    fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
    backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
  },
];

const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/lakhdeepjawandha/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/lakhdeepjawandha",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/lakhdeep",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@lakhdeepjawandha1",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/lakhdeepjawandha",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Machine Learning",
      subtitle: "- Andrew Ng",
      logo_path: "stanford_logo.png",
      certificate_link: "",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
  ],
};

// Replace your current experience object with:
// const experience = experienceData;
// const experience = experienceData || {
//   title: "Experience",
//   subtitle: "Work, Internship and Volunteership", 
//   description: "Loading experience data...",
//   sections: []
// };

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Articles, Blogs and Research.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    // {
    //   id: "neuro-symbolic-sudoku-solver",
    //   name: "Neuro-Symbolic Sudoku Solver",
    //   createdAt: "2023-07-02T00:00:00Z",
    //   description: "Paper published in KDD KiML 2023",
    //   url: "https://arxiv.org/abs/2307.00653",
    // },
    // {
    //   id: "mdp-diffusion",
    //   name: "MDP-Diffusion",
    //   createdAt: "2023-09-19T00:00:00Z",
    //   description: "Blog published in Paperspace",
    //   url: "https://blog.paperspace.com/mdp-diffusion/",
    // },
    // {
    //   id: "consistency-models",
    //   name: "Consistency Models",
    //   createdAt: "2023-10-12T00:00:00Z",
    //   description: "Blog published in Paperspace",
    //   url: "https://blog.paperspace.com/consistency-models/",
    // },
  ],
};

const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "animated_profile.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I’m available to assist with iOS development, ML, AI, React, React Native, Android, Python and Cloud.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I like to document some of my experiences in professional career journey as well as some technical knowledge sharing.",
    link: "https://medium.com/@lakhdeep",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Melbourne, Australia",
    locality: "Melbourne",
    country: "Australia",
    region: "Victoria",
    // postalCode: "95129",
    // streetAddress: "Saratoga Avenue",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/MkoMDvrrBjhuy2Bq9",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  majorProjects,
  publicationsHeader,
  publications,
  contactPageData,
};
